<div class="modal-header">
    <h4 class="modal-title">Adicionar Associado</h4>
    <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()">
    </button>
  </div>
  <div class="modal-body">
    <div class="row mt-1 mb-3" [formGroup]="formularioCadastroAssociado">
    
        <div class="bn-form-group col-md-8 m-2">
            <label for="combo">Agente Financeiro:</label>
            <select class="form-select" name="agenteFinanceiro"  formControlName="agenteFinanceiro">
                <option *ngFor="let agente of agentesFinanceirosHabilitados" [ngValue]="agente.id">{{agente.nome}} ({{agente.cnpj | bnCnpj:"XX.XXX.XXX/XXXX-XX"}})</option>
            </select>
        </div>

        <div class="bn-form-group col-md-6 m-2">
            <label>CNPJ Associado:</label>
            <input type="text" bn-mask-cnpj bn-valid-cnpj (blur)="tratarCNPJCadastro()"  maxlength="18"  class="form-control" name="cnpjAssociado" ngDefaultControl formControlName="cnpjAssociado" >
        </div>
        <div class="bn-form-group col-md-12 m-2">
            <label>Nome Agente Associado:</label>
            <input type="text" class="form-control" name="nomeRazaoSocialAssociado" ngDefaultControl formControlName="nomeRazaoSocialAssociado">
        </div>

    </div>
    <!-- <div *ngIf="mensagemAviso" class="alert alert-warning">
        {{mensagemAviso}}
    </div> -->
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    <button class="btn btn-primary" [disabled]="!formularioCadastroAssociado.valid" (click)="salvar()">Adicionar</button>
</div>